import axios from "./config.service";

export const deletePhoneById = (id: number) => {
  return axios.delete(`/phone/${id}`).then((r) => r.data) as Promise<void>;
}
